var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
        _c("div", { staticClass: "nk-block-between" }, [
          _c("div", { staticClass: "nk-block-head-content" }, [
            _c("h3", { staticClass: "nk-block-title page-title" }, [
              _vm._v(_vm._s(_vm.trans("configuration.configuration"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "nk-block-des text-soft" }, [
              _c("p", [_vm._v(_vm._s(_vm.trans("ip_filter.ip_filter")))]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-config-layout admin-linear-page" },
        [
          _c("configuration-sidebar", { attrs: { menu: "ip-filter" } }),
          _vm._v(" "),
          _c("div", { staticClass: "admin-config-panel" }, [
            _c(
              "div",
              {
                staticClass:
                  "admin-config-panel__inner admin-config-panel__inner--wide",
              },
              [
                _c("div", { staticClass: "admin-linear-head" }, [
                  _c("div", [
                    _c("span", { staticClass: "admin-linear-head__eyebrow" }, [
                      _vm._v("Security rules"),
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "admin-linear-head__title" }, [
                      _vm._v(_vm._s(_vm.trans("ip_filter.ip_filter"))),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "admin-linear-head__description" }, [
                      _vm._v(
                        "Define allowed or blocked IP ranges with concise descriptions so operators can audit access quickly."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "admin-linear-stat",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.trans("ip_filter.ip_filter_list"))),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.ip_filters && _vm.ip_filters.total
                              ? _vm.ip_filters.total
                              : 0
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("show-tip", {
                  attrs: { module: "ip_filter", tip: "tip_ip_filter" },
                }),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "admin-config-list-section",
                    attrs: {
                      "aria-labelledby": "admin-config-ip-filter-list-title",
                    },
                  },
                  [
                    _c(
                      "header",
                      {
                        staticClass:
                          "admin-config-list-head admin-config-list-head--split",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "admin-config-list-head__text" },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "admin-config-list-head__title",
                                attrs: {
                                  id: "admin-config-ip-filter-list-title",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.trans("ip_filter.ip_filter_list")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.ip_filters && _vm.ip_filters.total
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "admin-config-list-head__sub",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.trans(
                                            "general.total_result_found",
                                            { count: _vm.ip_filters.total }
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm.ip_filters
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "admin-config-list-head__sub admin-config-list-head__sub--empty",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.trans("general.no_result_found")
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "admin-config-list-head__actions" },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-ip-filter-create",
                                    modifiers: {
                                      "modal-ip-filter-create": true,
                                    },
                                  },
                                ],
                                staticClass:
                                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                attrs: { type: "button" },
                              },
                              [
                                _c("admin-icon", { attrs: { name: "plus" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.trans("general.add_new")) +
                                    "\n                        "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.ip_filters && _vm.ip_filters.total
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "admin-list-table-card admin-config-list-card",
                          },
                          [
                            _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table admin-data-table admin-data-table--config-list admin-linear-table mb-0",
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("ip_filter.start_ip")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("ip_filter.end_ip"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("ip_filter.description")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass:
                                            "admin-table-actions-cell",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.action"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.ip_filters.data,
                                      function (ip_filter) {
                                        return _c("tr", { key: ip_filter.id }, [
                                          _c("td", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "admin-linear-code",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(ip_filter.start_ip)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "admin-linear-code",
                                              },
                                              [_vm._v(_vm._s(ip_filter.end_ip))]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "admin-linear-primary",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    ip_filter.description || "-"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "admin-table-actions-cell",
                                            },
                                            [
                                              _c(
                                                "table-row-action-dropdown",
                                                [
                                                  _c(
                                                    "b-dropdown-item-button",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.editIpFilter(
                                                            ip_filter
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("admin-icon", {
                                                        attrs: {
                                                          name: "pencil",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.trans(
                                                              "general.edit"
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-dropdown-item-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "confirm",
                                                          rawName: "v-confirm",
                                                          value: {
                                                            ok: _vm.confirmDelete(
                                                              ip_filter
                                                            ),
                                                          },
                                                          expression:
                                                            "{ok: confirmDelete(ip_filter)}",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "admin-row-actions__danger",
                                                    },
                                                    [
                                                      _c("admin-icon", {
                                                        attrs: {
                                                          name: "trash",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.trans(
                                                              "ip_filter.delete_ip_filter"
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "admin-table-pagination-wrap" },
                              [
                                _c("pagination-record", {
                                  attrs: {
                                    "page-length":
                                      _vm.filterIpFilterForm.page_length,
                                    records: _vm.ip_filters,
                                  },
                                  on: {
                                    "update:pageLength": function ($event) {
                                      return _vm.$set(
                                        _vm.filterIpFilterForm,
                                        "page_length",
                                        $event
                                      )
                                    },
                                    "update:page-length": function ($event) {
                                      return _vm.$set(
                                        _vm.filterIpFilterForm,
                                        "page_length",
                                        $event
                                      )
                                    },
                                    updateRecords: _vm.getIpFilters,
                                  },
                                  nativeOn: {
                                    change: function ($event) {
                                      return _vm.getIpFilters.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ip_filters && !_vm.ip_filters.total
                      ? _c("module-info", {
                          attrs: {
                            module: "ip_filter",
                            title: "module_info_title",
                            description: "module_info_description",
                            icon: "ellipsis-v",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-ip-filter-create",
            "hide-footer": "",
            centered: "",
            lazy: "",
            "modal-class": "admin-modal-pro",
            "content-class": "admin-modal-pro__content",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _vm._v(_vm._s(_vm.trans("ip_filter.add_new_ip_filter"))),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("ip-filter-form", {
            on: {
              completed: _vm.getIpFilters,
              cancel: function ($event) {
                return _vm.$bvModal.hide("modal-ip-filter-create")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }